import gql from "graphql-tag";

export const deleteKnowledgeBaseSectionMutation = gql`
  mutation deleteKnowledgeBaseSection($id: ID!) {
    deleteKnowledgeBaseSection(id: $id) {
      id
    }
  }
`;
